<div class="al-alert-box" [ngClass]='boxColor'>
  <ng-content select=".icon" [ngClass]='iconColor'></ng-content>
  <ng-content select=".text"></ng-content>
  <ng-content select=".alert-button"></ng-content>
</div>
